import { request } from "./http";

/** Loads everything the dashboard needs in parallel. */
export async function fetchDashboard(signal) {
  const [summary, activeJobs, mechanicActivity, popularServices] = await Promise.all([
    request("/dashboard/summary",           { signal }),
    request("/dashboard/active-jobs",       { signal }),
    request("/dashboard/mechanic-activity", { signal }),
    request("/dashboard/popular-services",  { signal }),
  ]);
  return {
    summary:          summary || {},
    activeJobs:       activeJobs || [],
    mechanicActivity: mechanicActivity || [],
    popularServices:  popularServices || [],
  };
}
